import * as React from "react";
import getTime from "./getTime";
import getDate from "./getDate";
import getDays from "./getDays";

export default function SearchItemDetails(props) {
    const { item, j, getAllHighlights, siteName } = props;

    function getUrl(url) {
        if (url && url.indexOf("http") === -1) {
            url = window.location.protocol + "//" + window.location.host + url;
        }
        return url;
    }

    return (
        <div className="item" key={j}>
            <div className="row">
                <div className="col-1">
                    <div className="img-container">
                        <img className="img-fluid" title={item.category} alt={item.category + " Icon"} src={item.imagePath}></img>
                    </div>
                </div>
                <div className="col-11 ps-0">
                    <div className="item-title-wrapper">
                        {item.displayName != null && item.displayName.length > 0 &&
                            <div className="display-name">{item.displayName}</div>
                        }
                        {!siteName &&
                            <div className="item-category">
                                {item.category}
                            </div>
                        }
                        <a href={item.url} title={item.pageTitle + " " + j} target={(item.type === "page" || item.type === "event") ? "_self" : "_blank"}>
                            <div className="item-title">
                                {item.pageTitle}
                            </div>
                        </a>
                    </div>
                    <div className="item-highlights">
                        {item.type != "event" && item.type != "recurringEvent" && item.highlights && item.highlights && item.highlights.length > 0 &&
                            <div className="inner-text"
                                dangerouslySetInnerHTML={{ __html: getAllHighlights(item.highlights[0]) }}
                            ></div>
                        }
                    </div>
                    {(item.type == "event" || item.type == "recurringEvent") && item.recurringDetails &&
                        <div className="event-details">
                            <div className="event-date">{getDate(item.recurringDetails.startDateTime, item.recurringDetails.endDateTime)}</div>
                            {item.recurringDetails.weekDays && item.recurringDetails.weekDays.length > 0 &&
                                <React.Fragment>
                                    <div className="separator">|</div>
                                    <div className="event-week-days">{getDays(item.recurringDetails.weekDays)}</div>
                                </React.Fragment>
                            }
                            <div className="event-time">{getTime(item.recurringDetails.startDateTime, item.recurringDetails.endDateTime)}</div>
                            <div className="separator">|</div>
                            <div className="location">{item.recurringDetails.location}</div>
                        </div>
                    }
                    <div className="item-url">
                        <a href={item.url} title={item.pageTitle} target={(item.type === "page" || item.type === "event") ? "_self" : "_blank"}>
                            {getUrl(item.url)}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}